export default "__VITE_ASSET__DEhUjLCS__"